module.exports = __webpack_public_path__ + "files/farizon-borges.00a92e882d28aa273eeb7fa504348d8c.pdf";